module.exports = __webpack_public_path__ + "img/icon-volume-off.cab7ce71.svg";